import { useEffect, useState } from "react";
import { MapRef } from "react-map-gl/maplibre";

import { useGmwGeojsonQuery } from "@/queries/query-gmw";

const useViewState = (map: MapRef | null) => {
  const { data } = useGmwGeojsonQuery();
  const [beenApplied, setBeenApplied] = useState(false);

  useEffect(() => {
    if (!beenApplied && map && data?.features.length)
      (() => {
        let bounds: [number, number, number, number] = [10000, -10000, -10000, 10000];
        data.features.forEach((gmw) => {
          const [x, y] = gmw.geometry.coordinates;
          bounds = [
            Math.min(x, bounds[0]),
            Math.max(y, bounds[1]),
            Math.max(x, bounds[2]),
            Math.min(y, bounds[3]),
          ];
        });
        setBeenApplied(true);
        map.fitBounds(bounds, { padding: 20 });
      })();
  }, [map, beenApplied, data]);
};

export { useViewState };
